import { useAuth0 } from "@auth0/auth0-react";
import App from "../App";
import { loginUser, useAuth0Token } from "./http-requests";
import { loginUserRequestType} from "../common/type";

function LoginProcessing(user_email:string) {
  const { getToken } = useAuth0Token();

  const loginInternalProcessing = async (
      email: string, // 検索対象のEメールアドレス
  ) => {
    try {
      const requestParams: loginUserRequestType = {
        email, // 検索対象のEメールアドレス
      };
      await loginUser(await getToken(), requestParams);
    } catch (e: any){
      console.log("Error in loginInternalProcessing:", e);
    }
  };
  loginInternalProcessing(user_email);
}

const Login: React.FC = () => {
  const { user, isLoading, error, isAuthenticated, loginWithRedirect, } = useAuth0();

  if (error) {
    console.log("Auth0 authentication failed");
    return <div>Oops... {error.message}</div>;
  }
  if (isLoading) {
    console.log("Auth0 is loading");
    return <>Loading...</>;
  }
  if (!isAuthenticated) {
    console.log("User not authenticated, redirecting to login");
    loginWithRedirect();
    return <>not authenticated</>;
  }
  if (user === undefined) {
    console.log("User is undefined");
    return <>not authenticated</>;
  }

  // 顧客要望でアクセスを一時的にブロック
  // if(user.email == "kdx@naruto-u.ac.jp") {
  //   console.log("2026/03/17 Permit User");
  // } else if(user.email == "masafumi.hara@arithmer.co.jp") {
  //   console.log("2026/03/17 Permit User");
  // } else {
  //   console.log("2026/03/17 Block User");
  //   return (
  //     <div style={{
  //       display: "flex",
  //       justifyContent: "center",
  //       alignItems: "center",
  //       height: "100vh",
  //       fontSize: "48px"
  //     }}>
  //       調整中...
  //     </div>
  //   );
  // }

  LoginProcessing(String(user.email));

  return <App />;
}

export default Login;